import {motion} from "framer-motion";
import {FC} from "react";
import {CustomPageHeader} from "../CustomPageHeader.tsx";
import {useTranslation} from "react-i18next";
import {ModalPropsType} from "../../context/ModalContext.tsx";

export const ReferralProgramTerms: FC<ModalPropsType> = ({isOpen, onClose}) => {

    const {t} = useTranslation();

    const listItems = [1, 2, 3, 4, 5];
    return (
        <div
            className="fixed max-w-[640px] m-auto inset-0 z-[99999] flex items-center justify-center bg-black/50 backdrop-blur-sm"
            onClick={onClose}
        >
            {
                isOpen && (
                    <motion.div
                        className="w-full h-full bg-white flex flex-col"
                        initial={{y: 50, opacity: 0, scale: 0.8}}
                        animate={{y: 0, opacity: 1, scale: 1}}
                        exit={{y: 50, opacity: 0, scale: 0.8}}
                        transition={{duration: 0.3, ease: "easeInOut"}}
                        onClick={(e) => e.stopPropagation()} // Остановить всплытие
                    >
                        <CustomPageHeader title={t('modals.ReferralProgramTerms.header')} type={"BACK"} border
                                          onClickBack={onClose}/>
                        <div className="p-4 overflow-auto h-[calc(100vh - 160px)] custom-scrollBar">
                            {listItems.map((sectionIndex) => {
                                const title = t(`modals.ReferralProgramTerms.list.listItem_${sectionIndex}.title`);
                                const descList: string[] = [];

                                let descIndex = 1;
                                while (true) {
                                    const key = `modals.ReferralProgramTerms.list.listItem_${sectionIndex}.desc_${descIndex}`;
                                    const translated = t(key);
                                    if (translated === key) break;
                                    descList.push(translated);
                                    descIndex++;
                                }

                                return (
                                    <div key={sectionIndex} className="mb-[20px]">
                                        <h2 className="text-sm font-bold text-black mb-1">
                                            {sectionIndex}. {title}
                                        </h2>
                                        {descList.map((desc, i) => (
                                            <p key={i} className="text-sm mt-4">
                                                {sectionIndex}.{i + 1}. {desc}
                                            </p>
                                        ))}
                                    </div>
                                );
                            })}
                        </div>
                    </motion.div>
                )
            }

        </div>
    );
};